<header class="navigation-bar">
  <div class="ul-header">
    <div class="ul-header--red" />
    <div class="ul-header--yellow" />
  </div>
  <nav>
    <div>
      <a
        href="https://ulaval.ca"
        target="_blank"
      >
        <img
          alt="Université Laval"
          :src="require(`@/assets/medias/images/ulaval-logo.png`)"
          width="80"
          height="33"
        />
      </a>
    </div>
  </nav>
</header>